export enum TEST_IDS {
	PAGE_TITLE = 'search.LandingPage.title',
	HEADER_SEARCH_LINK = 'header.search.landingPageLink',
	LAST_SEARCHES = 'search.lastSearches',
	EXPLORE_GRID = 'search.exploreGrid',
	EXPLORE_GRID_LAST_VIEWED = 'search.exploreGrid.lastViewed',
	EXPLORE_GRID_RECOMMENDATION = 'search.exploreGrid.recommendation',
}
